// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback} from 'react';
import cn from 'classnames';
import {Text} from '../text';
import {Icon} from '../icon';
import {Button} from '../button';
import * as cns from './pagination.module.less';

const SEPARATOR = '...';
const DEF_WINDOW_SIZE = 3; // odd

function Fast_link({page, on_set, loading, active}){
    const set_page = useCallback(()=>on_set(page), [on_set, page]);
    if (active)
    {
        return <Text.m className={cn(cns.item, cns.item__current)}>
          {loading ? <Icon ico="spinner" size='m'/> : page+1}
        </Text.m>;
    }
    if (page==SEPARATOR)
    {
        return <Text.m className={cn(cns.item, loading&&cns.item__disabled)}
          tertiary>
          {SEPARATOR}
        </Text.m>;
    }
    return <Button on_click={set_page} size="m"
      color_scheme="tertiary" className={cns.item} view="link"
      disabled={loading}>
      {page+1}
    </Button>;
}

const num_ok = (num, max)=>num>=0 && num<=max;

const get_links = (current, max, window_size)=>{
    const left = new Set();
    const right = new Set();
    left.add(0);
    const wing_len = (window_size-1) / 2;
    let added = 0;
    for (let i=wing_len; i>0; i--)
    {
        const tg = current-i;
        if (num_ok(tg, max))
        {
            left.add(tg);
            added++;
        }
    }
    let add2right = wing_len-added;
    if (current-wing_len<=0)
        add2right++;
    if (current-wing_len<2)
        add2right++;
    for (let i=0; i<wing_len+add2right; i++)
    {
        const tg = current+i+1;
        if (num_ok(tg, max))
            right.add(tg);
    }
    right.add(max);
    let add2left = 0;
    const wing_lost_len = wing_len-(max-current);
    if (wing_lost_len>0)
        add2left = wing_lost_len;
    const wing_pos = current+wing_len;
    if (max-wing_pos<=0)
        add2left++;
    if (max-wing_pos<2)
        add2left++;
    for (let i=added+1; i<add2left+added+1; i++)
    {
        const tg = current-i;
        if (num_ok(tg, max))
            left.add(tg);
    }
    const left_sorted = Array.from(left).sort((a, b)=>a-b);
    const pages = new Set([...left_sorted, current, ...right]);
    return Array.from(pages).reduce((acc, p)=>{
        if (acc.length)
        {
            const last = acc.at(-1);
            if (p-last==2)
                acc.push(p-1);
            else if (p-last>2)
                acc.push('...');
        }
        acc.push(p);
        return acc;
    }, []);
};

export function Pagination({
    className,
    pagination={},
    loading,
    window_size=DEF_WINDOW_SIZE,
})
{
    const {page=0, max=0, dec, inc, set, total} = pagination;
    if (max==0)
        return null;
    const links = get_links(page, max, window_size);
    return <div className={cn(cns.root, className)}>
      <ul className={cns.list}>
        <li>
          <Button on_click={dec} disabled={page==0||loading}
            className={cns.item} color_scheme="accent" size="m"
            tip="Go to prev page" view="link" ico="chevron_left"/>
        </li>
        {links.map((l, i)=><li key={i}>
          <Fast_link page={l} loading={loading} on_set={set}
            active={page==l}/>
        </li>)}
        <li>
          <Button on_click={inc} disabled={page==max||loading}
            className={cns.item} color_scheme="accent" size="m"
            tip="Go to next page" view="link" ico="chevron_right"/>
        </li>
        {total
            ? <Text.xs>Total: {total}</Text.xs>
            : null
        }
      </ul>
    </div>;
}
